import FolderForm from './FolderForm';

new FolderForm();
